import { cn } from "@/lib/utils";

const statusConfig = {
  pending_first_call: {
    label: "Pending First Call",
    className: "bg-gray-100 text-gray-700",
  },
  awaiting_funds: {
    label: "Awaiting Payment",
    className: "bg-blue-100 text-blue-700",
  },
  active_installment: {
    label: "Installment Active",
    className: "bg-purple-100 text-purple-700",
  },
  nurture: { label: "Nurture", className: "bg-yellow-100 text-yellow-700" },
  unreachable: {
    label: "Unreachable",
    className: "bg-orange-100 text-orange-700",
  },
  completed: {
    label: "Completed",
    className: "bg-emerald-100 text-emerald-700",
  },
};

const priorityConfig = {
  overdue: {
    label: "Overdue",
    dot: "bg-red-500",
    className: "bg-red-100 text-red-700",
  },
  today: {
    label: "Today",
    dot: "bg-amber-500",
    className: "bg-amber-100 text-amber-700",
  },
  upcoming: {
    label: "Upcoming",
    dot: "bg-green-500",
    className: "bg-green-100 text-green-700",
  },
  none: {
    label: "Not Set",
    dot: "bg-gray-300",
    className: "bg-gray-100 text-gray-500",
  },
};

export function getPriorityFromDate(nextActionDate) {
  if (!nextActionDate) return "none";
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  const d = new Date(nextActionDate);
  if (d < start) return "overdue";
  if (d < end) return "today";
  return "upcoming";
}

export function FollowUpStatusBadge({ status, className }) {
  const config = statusConfig[status] || {
    label: status || "Unknown",
    className: "bg-gray-100 text-gray-600",
  };
  return (
    <span
      className={cn(
        "text-[9px] font-semibold px-1.5 py-0.5 rounded-full whitespace-nowrap",
        config.className,
        className,
      )}
    >
      {config.label}
    </span>
  );
}

export function PriorityBadge({ nextActionDate, className }) {
  const priority = getPriorityFromDate(nextActionDate);
  const config = priorityConfig[priority];
  return (
    <span
      className={cn(
        "text-[9px] font-semibold px-1.5 py-0.5 rounded-full whitespace-nowrap",
        config.className,
        className,
      )}
    >
      {config.label}
    </span>
  );
}

export function PriorityDot({ nextActionDate, className }) {
  const priority = getPriorityFromDate(nextActionDate);
  const config = priorityConfig[priority];
  return (
    <span
      className={cn("h-2 w-2 rounded-full shrink-0", config.dot, className)}
    />
  );
}

export { priorityConfig, statusConfig };
